<template>
	<div>
        123456789
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
  import { wcLogin } from '@/api/user/login';

export default {
	name: 'codelogin',

	data() {
		return {

		}
	},

	computed: {
      ...mapGetters([ 'lang' ]),
    },

    mounted() {
        const { code, state } = this.$route.query
        let params = {
            // code: code,
            code: 'oKuJN5-qIZHXU5ux13m-wHk-ZwhM',
            state: state
        }
        wcLogin(params).then(res => {
            console.log("🚀 ~ file: wxloginRedirect.vue ~ line 26 ~ mounted ~ mounted", res)
            
        })
    },

	created() {

	},
}
</script>

<style lang="scss" scoped>

</style>

